import React, { useEffect, useState } from "react";
import {
  Typography,
  Stack,
  Box,
} from "@mui/material";
import ReactApexChart from "react-apexcharts";
import "./attendancepercentage.scss";
import { useQuery } from "@apollo/client";

import { AuthContext } from "../../../Context/AuthContext";
import { translateLauguage } from "../../../Function/Translate";

import { GET_ATTENDACE_RATE_SHOW_BY_SCHOOL } from "../../../Schema/Dashboard";

import LoadingPage from "../../Include/LoadingPage";

export default function AttendancePercentageBySchool({ academicYearId, academicYearName }) {
  // Change Language
  const { language } = React.useContext(AuthContext);
  const { t } = translateLauguage(language);

  const [totalData, setTotalData] = useState([]);

  const { loading, refetch } = useQuery(GET_ATTENDACE_RATE_SHOW_BY_SCHOOL, {
    variables: {
      academicYearId: academicYearId ?? null,
    },
    onCompleted: ({ getAttendanceRateChartShowBySchool }) => {
      setTotalData(getAttendanceRateChartShowBySchool);
    },
    onError: (err) => {
      console.log("Error::", err?.message);
    },
  });

  const labelData = totalData?.map((e) => {
    return language === "en" ? e?.labelNameEng : e?.labelNameKh;
  });

  const percentage = totalData?.map((e) => e?.percentage)


  // const maxSeriesData = Math.max(...(percentage ? percentage : 0));

  useEffect(() => {
    refetch();
  }, [academicYearId]);




  const state = {
    options: {
      chart: {
        type: "bar",
        height: 350,
        fontFamily: "Khmer OS Siemreap",
        stacked: false,
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "50%",
          endingShape: "rounded",
          dataLabels: {
            position: "top", // top, center, bottom
          },
        },
      },
      dataLabels: {
        enabled: true,
        offsetY: -25,
        style: {
          fontSize: "12px",
          colors: ["#304758"],
        },
        formatter: function (val, opts) {
          if (val > 0) {
            return val + " %";
          } else {
            return "0 %";
          }
        },
      },
      stroke: {
        show: true,
        width: 2,
        colors: ["transparent"],
      },
      xaxis: {
        categories: labelData,
        // categories: ["A", "B", "C", "D", "E"],
        labels: {
          rotate: -45, // Rotates labels to -45 degrees
          rotateAlways: true, // Ensures rotation applies
          maxHeight: 150,
        },
      },
      yaxis: {
        // max: maxSeriesData + 5,
        labels: {
          style: {
            fontFamily: "Siemreap",
          },
          formatter: function (val) {
            return val?.toFixed(0);
          },
        },
      },
      tooltip: {
        y: {
          formatter: function (val) {
            if (val > 0) {
              return val + " %";
            } else {
              return 0 + " %";
            }
          },
        },
      },
      fill: {
        opacity: 1,
      },
    },
    series: [
      {
        name: t("percentage"),
        data: percentage,
        // data: [10, 15, 20, 25, 30],
        color: "#0071F1",
      },

    ],
  };

  return (
    <Box className="total-enrollment-by-chart-percentage">
      <Stack direction="row" alignItems="center" justifyContent="center">
        <Typography
          className={language === "en" ? "chart-title" : "chart-title-kh"}
        >
          {t("statistic_attendance_percentage")}{academicYearName && language === "kh" ? `ឆ្នាំសិក្សា ${academicYearName}` : ` ${academicYearName}`}
        </Typography>
      </Stack>

      {
        loading ? <LoadingPage /> :
          <div id="chart">
            <ReactApexChart
              options={state.options}
              series={state.series}
              type="bar"
              height={400}
            />
          </div>
      }
    </Box>
  );
}
